import classNames from 'classnames'
import PropTypes from 'prop-types'
import Modal from 'react-modal'
import { useTranslation } from 'react-i18next'

import SubmitButton from '../../../../common/buttons/SubmitButton'
import { ReactComponent as WarningIcon } from '../../../../../assets/images/common/icons/warning-icon.svg'
import { ReactComponent as ModalXIcon } from '../../../../../assets/images/common/icons/modal-X-icon.svg'
import './DropEnrollmentModal.scss'
import MCElement from '../../../../common/MCElement'
import Input from '../../../../common/form/Input'

const DropEnrollmentModal = ({ showModal,
  closeModal,
  coachMessage,
  handleCoachMessageChange,
  handleRemoveEnrollment,
  enrollment,
  notifyViaEmail,
  handleCheckboxChange,
  isLoading,
}) => {
  const { t } = useTranslation()
  const isEnrollmentApproved = enrollment.status === 'active'
  const enrollmentActionTitle = isEnrollmentApproved
    ? t('programs.manage.dropEnrollmentModal.dropTitle')
    : t('programs.manage.dropEnrollmentModal.declineTitle')

  return (
    <Modal
      isOpen={showModal}
      onRequestClose={closeModal}
      contentLabel={t('programs.manage.dropEnrollmentModal.contentLabel')}
      className={classNames('drop-enrollment-modal-content')}
      autoFocus
    >
      <div id='DropEnrollmentModal'>
        <div className='animated fadeIn'>
          <div className='d-flex justify-content-end text-align-right'>
            <ModalXIcon id='modalXIcon' onClick={closeModal} />
          </div>
          <div className='d-flex flex-column justify-content-center align-items-center'>
            <WarningIcon id='warningIcon' />
            <p className='title'>{enrollmentActionTitle}</p>
            <p className='sub-title'>
              {isEnrollmentApproved
                ? t('programs.manage.dropEnrollmentModal.confirmDrop')
                : t('programs.manage.dropEnrollmentModal.confirmDecline')}
            </p>
            <p className='sub-title mt-2'>
              {isEnrollmentApproved
                ? t('programs.manage.dropEnrollmentModal.additionalMessageDrop')
                : t('programs.manage.dropEnrollmentModal.additionalMessageDecline')}
            </p>
            <Input
              name='description'
              type='textarea'
              onChange={handleCoachMessageChange}
              placeholder={t('programs.common.customMessageFamily')}
              value={coachMessage}
              classNames={{ inputContainer: 'coachMessageInputContainer', inputContainerWrapper: 'mt-3 coachMessageWrapper' }}
            />
          </div>
          <div>
            <div className='row py-3 justify-content-center align-items-center'>
              <MCElement
                type='checkbox'
                label={t('programs.manage.dropEnrollmentModal.doNotNotify')}
                isSelected={!notifyViaEmail}
                clicked={handleCheckboxChange}
              />
              <div className='col-12'>
                <SubmitButton
                  onClick={handleRemoveEnrollment}
                  buttonMessage={enrollmentActionTitle}
                  buttonColor='orange-button'
                  loading={isLoading}
                />
              </div>
              <div className='col-12'>
                <SubmitButton
                  onClick={closeModal}
                  buttonMessage={t('common.cancel')}
                  buttonColor='navy-button'
                  disabled={isLoading}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  )
}

DropEnrollmentModal.propTypes = {
  showModal: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  coachMessage: PropTypes.string,
  handleCoachMessageChange: PropTypes.func.isRequired,
  handleRemoveEnrollment: PropTypes.func.isRequired,
  enrollment: PropTypes.object.isRequired,
  notifyViaEmail: PropTypes.bool.isRequired,
  handleCheckboxChange: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
}

export default DropEnrollmentModal
